import React from 'react';
import PropTypes from 'prop-types';
import { Card, Label } from 'semantic-ui-react';

import FeedEvent, {
  FeedLeftImage,
  FeedTitleAndDescription,
} from './feed-event';

const getCampaignLabel = type => {
  switch (type) {
  case 'ACR':
    return <Label size="mini" basic color="orange">ACR</Label>;
  case 'AUTOMATED':
    return <Label size="mini" basic color="pink">AUTOMATED</Label>;
  default:
    return <Label size="mini" basic color="green">MANUAL</Label>;
  }
};

const CampaignCreatedEvent = ({
  createdDate,
  messageData: {
    resource: {
      id,
      createdBy,
      name,
      campaignType,
    },
  },
  isCompact,
}) => (
  <FeedEvent
    isCompact={isCompact}
    actionText="added a new campaign"
    createdBy={createdBy}
    createdDate={createdDate}
  >
    <Card
      fluid
      onClick={() => window.open(`/campaign/${id}/collaborations`, '_blank')}
    >
      <Card.Content>
        <FeedLeftImage
          src="/icons/campaign-management.svg"
        />
        <FeedTitleAndDescription
          title={name}
          description={getCampaignLabel(campaignType)}
          isCampaign
        />
      </Card.Content>
    </Card>
  </FeedEvent>
);

CampaignCreatedEvent.propTypes = {
  messageData: PropTypes.object.isRequired,
  createdDate: PropTypes.string.isRequired,
  isCompact: PropTypes.bool.isRequired,
};

export default CampaignCreatedEvent;



/** WEBPACK FOOTER **
 ** ./src/containers/event-feed/card-events/campaign-created-event.js
 **/